import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { PermisoService } from './permiso.service';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { GeneralService } from './general.service';

@Injectable()
export class HomeService {
    constructor(
        private http: HttpInterceptor,
         private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService
    ) { }

    getValoresDolar(): Observable<any> {
        return this.permisoService.getPermisoAction('ESTADISTICA-VALORES-DOLAR')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({})
                    )
                    .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                        (respuesta: Response) => respuesta.json()
                    );
            });
    }

    getCotizacionesEstados(
        fechaDesde: string = null,
        fechaHasta: string = null,
        IdUsuario: number = null
    ): Observable<any> {
        return this.permisoService.getPermisoAction('ESTADISTICA-COTIZACIONES-ESTADOS')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            filtros: {
                                fechaDesde: fechaDesde,
                                fechaHasta: fechaHasta,
                                usuario: IdUsuario
                            }
                        })
                    )
                    .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                        (respuesta: Response) => respuesta.json()
                    );
            });
    }

    getCotizacionesEstadosMes(
        fechaDesde: string = null,
        fechaHasta: string = null,
        IdUsuario: number = null
    ): Observable<any> {
        return this.permisoService.getPermisoAction('ESTADISTICA-COTIZACIONES-ESTADOS-MES')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            filtros: {
                                fechaDesde: fechaDesde,
                                fechaHasta: fechaHasta,
                                usuario: IdUsuario
                            }
                        })
                    )
                    .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                        (respuesta: Response) => respuesta.json()
                    );
            });
    }

    getTarjetas(
        fechaDesde: string = null,
        fechaHasta: string = null,
        IdUsuario: number = null
    ): Observable<any> {
        return this.permisoService.getPermisoAction('ESTADISTICA-TARJETAS')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            filtros: {
                                fechaDesde: fechaDesde,
                                fechaHasta: fechaHasta,
                                usuario: IdUsuario
                            }
                        })
                    )
                    .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                        (respuesta: Response) => respuesta.json()
                    );
            });
    }
}